import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

import { postStreamItem } from '../../../api/items';

import { mergeItemWithUserData } from '../../../utils/items';

import { POST_STREAM_ITEM_METHODS } from '../../../components/Items/constants/postStreamItemMethods';

export const addBuzzToThread = createAsyncThunk(
  'items/addBuzzToThread',
  async ({ path, params }, { signal, rejectWithValue }) => {
    const source = axios.CancelToken.source();
    signal.addEventListener('abort', () => {
      source.cancel();
    });
    try {
      const [itemResponse, itemUserDataResponse] = await postStreamItem(
        {
          path,
          params: {
            method: POST_STREAM_ITEM_METHODS.addThread,
            anchorPath: params.anchorPath,
          },
        },
        {
          cancelToken: source.token,
        },
      );

      return mergeItemWithUserData(itemResponse, itemUserDataResponse);
    } catch (error) {
      return rejectWithValue(error.response.status);
    }
  },
);
